const getToken = () => {
  return document.querySelector('[name="csrf-token"]').content;
}

export default getToken;
